import api from "../api";

const state = {
  user: {},
  users: [],
  lastLogAsAccounts: null,
};

const getters = {
  userHasInfo: (state) => {
    return Boolean(
      state.user.firstname && state.user.lastname && state.user.email
    );
  },
  users: (state) => {
    return state.users;
  },
};

const mutations = {
  GET(state, user) {
    state.user = user;
  },

  UPDATE(state, user) {
    state.user = user;
  },
  SET_USERS(state, users) {
    state.users = users;
  },
  DELETE_USER(state, user) {
    const index = state.users.findIndex((element) => element._id === user);
    if (index > -1) {
      state.users.splice(index, 1);
    }
  },
  ADD_LAST_USER(state, user) {
    state.users.push(user);
  },
  SET_LAST_LOG_AS_ACCOUNTS(state, accounts) {
    state.lastLogAsAccounts = Array.isArray(accounts) ? accounts : [];
  },
  ADD_LAST_LOG_AS_ACCOUNT_FULL(state, account) {
    if (!Array.isArray(state.lastLogAsAccounts)) state.lastLogAsAccounts = [];
    const siteId = account?.site?._id || account?._id;
    state.lastLogAsAccounts = [
      account,
      ...state.lastLogAsAccounts.filter(
        (a) => (a?.site?._id || a?._id) !== siteId
      ),
    ].slice(0, 10);
  },
  SET_LAST_LOG_AS_SITE_IDS(state, ids) {
    if (!state.user) state.user = {};
    state.user.lastLogAsSiteIds = ids;
  },
};

const actions = {
  async getUser({ commit }, { userId }) {
    try {
      const user = await api.getUser(userId);
      commit("GET", user);
    } catch (err) {
      throw err;
    }
  },

  async updateUser({ commit }, { userId, dataToUpdate }) {
    try {
      const user = await api.updateUser(userId, dataToUpdate);
      commit("UPDATE", user);
    } catch (err) {
      throw err;
    }
  },
  async getUsers({ commit }, { siteId }) {
    try {
      const users = await api.getUsers({ siteId });
      commit("SET_USERS", users);
    } catch (err) {
      throw err;
    }
  },
  async addUser({ commit }, { data }) {
    try {
      const lastUser = await api.addUser(data);
      commit("ADD_LAST_USER", lastUser);
    } catch (err) {
      throw err;
    }
  },
  async deleteUser({ commit }, user) {
    try {
      await api.deleteUser(user);
      commit("DELETE_USER", user);
    } catch (err) {
      throw err;
    }
  },
  async fetchLastLogAsAccounts({ state, commit }, { userId }) {
    if (state.lastLogAsAccounts !== null) return; // ya cargado
    const accounts = await api.getLastLogAsAccount(userId);
    commit("SET_LAST_LOG_AS_ACCOUNTS", accounts);
  },

  async addLastLogAsAccountFull(
    { state, commit, dispatch },
    { userId, account }
  ) {
    const siteId = account?.site?._id || account?._id;
    if (!siteId) return;

    commit("ADD_LAST_LOG_AS_ACCOUNT_FULL", account);

    const prev = Array.isArray(state.user?.lastLogAsSiteIds)
      ? state.user.lastLogAsSiteIds
      : [];
    const nextIds = [siteId, ...prev.filter((id) => id !== siteId)].slice(
      0,
      10
    );

    await dispatch("updateUser", {
      userId,
      dataToUpdate: { lastLogAsSiteIds: nextIds },
    });
    commit("SET_LAST_LOG_AS_SITE_IDS", nextIds);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
